import React from "react";
import clsx from "clsx";

// Custom.
import { PreviewFormProps } from "./global";
import { useStyles } from "ui/styles/previewLayout";
import Layout from "./Layout";

const PreviewLayout: React.FC<PreviewFormProps> = (props) => {
  const {
    className,
    leftColumn,
    leftColumnProps,
    rightColumn,
    rightColumnProps,
  } = props;
  const classes = useStyles();

  return (
    <Layout>
      <div className={clsx(classes.root, className)}>
        {leftColumn && (
          <div className={classes.leftColumn}>
            <div {...leftColumnProps}>{leftColumn}</div>
          </div>
        )}
        {rightColumn && (
          <div className={classes.rightColumn}>
            <div {...rightColumnProps}>{rightColumn}</div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default PreviewLayout;
